"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSLEditablePopover = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var dsl_schema_ui_1 = require("@newfront-insurance/dsl-schema-ui");
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var popover_1 = require("../table/popover");
function DSLEditablePopover(_a) {
    var accountUuid = _a.accountUuid, schema = _a.schema, propertyKey = _a.propertyKey, cellRef = _a.cellRef, onClose = _a.onClose, _b = _a.initialValues, initialValues = _b === void 0 ? { data: {} } : _b, onSubmit = _a.onSubmit;
    return (react_1.default.createElement(popover_1.CellPopover, { cellRef: cellRef, onClose: onClose },
        react_1.default.createElement(formik_1.Formik, { onSubmit: onSubmit, initialValues: initialValues, validateOnChange: false }, function (_a) {
            var handleSubmit = _a.handleSubmit, isSubmitting = _a.isSubmitting;
            return (react_1.default.createElement("form", { onSubmit: handleSubmit },
                react_1.default.createElement(core_ui_1.Padding, { top: 24, x: 24, bottom: 12 },
                    react_1.default.createElement(dsl_schema_ui_1.SchemaInputContext.Provider, { value: { schema: schema, accountUuid: accountUuid } },
                        react_1.default.createElement(dsl_schema_ui_1.SchemaInputField, { propertyKey: propertyKey, name: "data", schema: schema }))),
                react_1.default.createElement(popover_1.CellPopoverFooter, { loading: isSubmitting })));
        })));
}
exports.DSLEditablePopover = DSLEditablePopover;
